import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FaUser, FaComment, FaArrowRight } from 'react-icons/fa';
import Base from './Base';

function Blog() {
  const fallbackImg = "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&q=80";

  const articles = [
    {
      title: "Benefiting From Healthcare Shouldn't Be A Matter Of Luck",
      date: "25 Jan",
      author: "Admin",
      comments: "02",
      desc: "Our medical center we are committed to delivering exceptional healthcare services tailored to meet the needs of every patient our center is equipped",
      img: "https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?w=800&q=80&fit=crop"
    },
    {
      title: "Caring For The Whole Patient Not Just Your Symptoms",
      date: "22 Jan",
      author: "Admin",
      comments: "03",
      desc: "Our medical center we are committed to delivering exceptional healthcare services tailored to meet the needs of every patient our center is equipped",
      img: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=800&q=80&fit=crop"
    },
    {
      title: "The Future of Telemedicine in Healthcare",
      date: "20 Jan",
      author: "Admin",
      comments: "05",
      desc: "Telemedicine is revolutionizing how patients access healthcare services, making medical consultations more convenient and accessible than ever before.",
      img: "https://images.unsplash.com/photo-1551076805-e1869033e561?w=800&q=80&fit=crop"
    },
    {
      title: "Preventive Care: Your First Line of Defense",
      date: "18 Jan",
      author: "Admin",
      comments: "08",
      desc: "Regular check-ups and preventive care can help detect health issues early, leading to better outcomes and lower healthcare costs.",
      img: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800&q=80&fit=crop"
    },
    {
      title: "Mental Health Awareness in Modern Healthcare",
      date: "15 Jan",
      author: "Admin",
      comments: "12",
      desc: "Mental health is an integral part of overall wellness. Learn how our healthcare system addresses medical health needs comprehensively.",
      img: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80&fit=crop"
    },
    {
      title: "Advancements in Medical Technology",
      date: "12 Jan",
      author: "Admin",
      comments: "07",
      desc: "From AI diagnostics to robotic surgery, medical technology is transforming patient care and improving treatment outcomes worldwide.",
      img: "https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=800&q=80&fit=crop"
    }
  ];

  return (
    <Base>
      <div className="dark:bg-dark min-h-screen transition-colors duration-200">
        <Helmet><title>Blog | Aman Medical Complex Gilgit</title></Helmet>

        {/* Page Title Section */}
        <section className="relative py-32 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://images.unsplash.com/photo-1512678080530-7760d81faba6?auto=format&fit=crop&q=80&w=1600"
              alt="Medical Header Background"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#002147]/80 dark:bg-gray-900/90"></div>
          </div>
          <div className="container mx-auto px-4 text-center relative z-10">
            <h1 className="text-5xl md:text-6xl font-black text-white mb-6 tracking-tight">Our Blog</h1>
            <div className="flex items-center justify-center gap-2 text-[#007bff] font-bold uppercase tracking-[0.2em] text-sm">
              <Link to="/" className="hover:text-white transition-colors">Home</Link>
              <span>/</span>
              <span className="text-white/60">Blog</span>
            </div>
          </div>
        </section>

        <section className="py-24 container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((article, i) => (
              <div key={i} className="bg-white dark:bg-gray-700 rounded-[30px] overflow-hidden shadow-lg border border-gray-100 dark:border-gray-600 group">
                <div className="relative h-64 overflow-hidden bg-gray-200 dark:bg-gray-600">
                  <img
                    src={article.img}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = fallbackImg;
                    }}
                  />
                  <div className="absolute bottom-4 right-4 bg-[#007bff] text-white px-4 py-2 rounded-xl font-black text-sm shadow-lg">
                    {article.date}
                  </div>
                </div>
                <div className="p-8">
                  <div className="flex items-center gap-4 text-gray-500 dark:text-gray-400 text-sm font-medium mb-4">
                    <span className="flex items-center gap-2">
                      <FaUser className="text-primary" size={14} /> {article.author}
                    </span>
                    <span className="flex items-center gap-2">
                      <FaComment className="text-primary" size={14} /> {article.comments} Comment
                    </span>
                  </div>
                  <h3 className="text-2xl font-black text-[#002147] dark:text-white mb-4 leading-tight hover:text-primary cursor-pointer transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-gray-500 dark:text-gray-400 mb-6 leading-relaxed text-sm">
                    {article.desc}
                  </p>
                  <Link to="#" className="group bg-[#f0f5ff] text-primary px-5 py-2.5 rounded-full font-bold text-sm flex items-center gap-2 hover:bg-[#007bff] hover:text-white transition-all duration-300 hover:scale-105 active:scale-95 shadow-sm inline-block w-fit">
                    Read More <FaArrowRight size={12} className="group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </Base>
  );
}

export default Blog;

